import React, { useState, useEffect } from 'react';
import { injectIntl } from 'react-intl';
import { getRemotedbUrl, i18nIntl } from '../../lib/ep.js';

import { SquaredButton } from '../builder/ActionButton';
import FloatingLayer from '../builder/FloatingLayer';
import SectionSubtitle from '../builder/SectionSubtitle';
import SectionTitle from '../builder/SectionTitle';
import Spinner from '../builder/Spinner';
import Tooltip from '../builder/Tooltip';

import UserName from '../front/UserName';

import { sweep as const_sweep } from './bootstrap';

const SweepBlacklistSuggestLayer = ({ sweep, ...props }) => {
	const i18n = (m, c) => i18nIntl(m, props.intl, c);

	const [ is_loaded, setIsLoaded ] = useState(false);

	const fetched = (data) => {
		window.suggestions = window.suggestions.concat(data);
	};

	const fetchSuggestions = (page, cb) => {
		$.get(getRemotedbUrl(`/sweeps/fetch_suggestions_blacklist/${sweep.id}`), (res) => {
			if(res.status == 1) {
				window.suggestions = res.elements;
				setParentSuggestion(res.elements);
			}

			setIsLoaded(true);
			if(cb != undefined) cb();
		}, 'JSON');
	};

	useEffect(() => {
		if(window.suggestions.length == 0) {
			fetchSuggestions(1, (d) => fetched(d.data));
			return;
		}

		setIsLoaded(true);
	}, []);

	const setParentSuggestion = (new_suggestion) => {
		for(let i in new_suggestion) {
			window.suggestions[i] = new_suggestion[i];
		}
	};

	const blacklist = (participant) => {
		$.post(getRemotedbUrl(`/sweeps/action_blacklist/${participant.network}`), participant, () => {
			for(let i in window.suggestions) {
				if(window.suggestions[i].fbuid === participant.fbuid && participant.page.id == window.suggestions[i].page.id) {
					window.suggestions.splice(i, 1);
					window.blacklist[participant.fbuid] = participant.network;
					setParentSuggestion(window.suggestions);
					break;
				}
			}
		});
	};

	return (
		<FloatingLayer
			backButton={props.back}
		>
			<div class="without_actions">
				<SectionTitle>Blacklist candidates</SectionTitle>

				<SectionSubtitle>Blacklist candidates are participants that we think you may want to include in the blacklist for this page. The list of canditates is based on users that you've added to the blacklist for other Facebook pages.</SectionSubtitle>

				{(is_loaded === false) && (
					<div class="gui_pos_rel gui_not_in_top">
						<Spinner
							autotranslate={false}
						>{`${i18n("Searching for candidates")}...`}</Spinner>
					</div>
				)}

				{(is_loaded && window.suggestions.length > 0) && (
					<table
						class="gui_not_in_top_big gui_list_table gui_huge_dom_content"
						style={{ width:'100%' }}
						cellSpacing="0"
						cellPadding="0"
					>
						<thead>
							<tr class="list_header">
								<th />

								<th>{i18n("***Name")}</th>

								<th class="gui_text_align_center">{i18n("Blacklisted")}</th>
							</tr>
						</thead>

						<tbody>
							{window.suggestions.map((participant, i) => {
								return (
									<tr key={`participant_${i}`}>
										<td>{i + 1}</td>

										<td>
											<div class="gui_flexbox gui_flex_row gui_flex_nowrap gui_flex_align_center">
												{(sweep.network == const_sweep.ID_MULTI) && (
													<SquaredButton
														color="black"
														icon={`ep-${participant.network}`}
														_class={{ other:'gui_withoutEvents' }}
														aria-label="Participant network"
													/>
												)}

												<UserName
													linked={false}
													user={participant}
													tooltip={<Tooltip
														autotranslate={false}
													>{(participant.from_page.name) ? props.intl.formatMessage({
														id:"Found in {page_name} blacklist",
													}, {
														page_name:participant.from_page.name,
													}) : i18n("Found in your old blacklist")}</Tooltip>}
												/>
											</div>
										</td>

										<td class="gui_text_align_center">
											<SquaredButton
												tooltip={<Tooltip
													with_icon={false}
													autotranslate={false}
													size="big"
												>{props.intl.formatMessage({
													id:"Add to {page_name} blacklist",
												}, {
													page_name:participant.page.name,
												})}</Tooltip>}
												color='black'
												icon='knk-checkbox-off'
												_class={{ first:true }}
												onClick={() => blacklist(participant)}
												aria-label="Add to blacklist"
											/>
										</td>
									</tr>
								)}
							)}
						</tbody>
					</table>
				)}

				{(is_loaded && window.suggestions.length == 0) && (
					<div>{i18n("There are no candidates")}</div>
				)}
			</div>
		</FloatingLayer>
	);
};

export default injectIntl(SweepBlacklistSuggestLayer);